module.exports = __webpack_public_path__ + "img/Mongolia_Badges_01_FeelMongolia.7c064423.svg";